<template>
  <el-form ref="form" :model="dataInfo"  :rules="rules" :hide-required-asterisk="true" label-position="top">
    <div class="white-box">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="commissionId" label="申报平台">
              <el-radio-group v-model="dataInfo.commissionId" :disabled="disabled">
                <el-radio v-for="(item) in gwhList" :key="item.id" :label="item.id" >{{item.name}}</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <!-- 基本情况 -->
    <div class="white-box">
      <div class="label">基本情况</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="dataInfo.name" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="dataInfo.sex" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in sexOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="中国籍填写身份证号码（其他填写护照号码）" prop="zjhm">
            <el-input v-model="dataInfo.zjhm" placeholder="请输入" :disabled="disabled" @blur="onZjhmBlur"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="国籍（户籍所在地）" prop="hjszd">
            <el-input v-model="dataInfo.hjszd" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否华裔" prop="sfhy">
            <el-radio-group v-model="dataInfo.sfhy" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in yesOrNoOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出生年月" prop="birthDay">
            <el-date-picker v-model="dataInfo.birthDay" type="month" value-format="yyyy-MM" placeholder="请选择" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="最高学历" prop="xl">
            <el-select v-model="dataInfo.xl" placeholder="请选择" :disabled="disabled">
              <el-option v-for="item in highestEducationOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业院校" prop="byyx">
            <el-input v-model="dataInfo.byyx" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="技术职称" prop="jszc">
            <el-input v-model="dataInfo.jszc" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="所学专业" prop="sxzy">
            <el-input v-model="dataInfo.sxzy" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="从事专业" prop="cszy">
            <el-input v-model="dataInfo.cszy" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="归口行业分类" prop="gkhyfl">
            <el-select v-model="dataInfo.gkhyfl" placeholder="请选择" :disabled="disabled">
              <el-option v-for="item in gkhyflOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="dataInfo.email" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="dataInfo.phone" placeholder="请输入"  :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系地址" prop="lxdz">
            <el-input v-model="dataInfo.lxdz" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="回国（来华）前工作单位" prop="hgqgzdw">
            <el-input v-model="dataInfo.hgqgzdw" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="回国（来华）前工作职务" prop="hgqgzzw">
            <el-input v-model="dataInfo.hgqgzzw" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="现工作单位" prop="xgzdw">
            <el-input v-model="dataInfo.xgzdw" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="现工作职务" prop="xgzzw">
            <el-input v-model="dataInfo.xgzzw" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="专家类别" prop="zjlb">
            <el-input v-model="dataInfo.zjlb" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授予时间" prop="sysj">
            <el-date-picker v-model="dataInfo.sysj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="8">
          <el-form-item label="是否已在临安注册成立公司" prop="sfclgs">
            <el-radio-group v-model="dataInfo.sfclgs" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in yesOrNoOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInfo.sfclgs == YES_OR_NO.YES.value">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="dataInfo.companyName" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInfo.sfclgs == YES_OR_NO.YES.value">
          <el-form-item label="公司地址" prop="companyAddr">
            <el-input v-model="dataInfo.companyAddr" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="dataInfo.sfclgs == YES_OR_NO.YES.value">
        <el-col :span="8">
          <el-form-item label="统一社会信用代码" prop="uscc">
            <el-input v-model="dataInfo.uscc" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="注册时间" prop="zcsj">
            <el-date-picker v-model="dataInfo.zcsj" type="date" value-format="yyyy-MM-dd" placeholder="请选择" :disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <!-- 学习经历 -->
    <div class="white-box">
      <div class="flex-row">
        <div class="label">学习经历</div><span class="label-tip">（从大学开始填写，年份从小到大排列）</span>
      </div>

      <el-form-item label="" prop="studyExpList">
        <el-table :data="dataInfo.studyExpList" border>
          <el-table-column label="起止年月" width="200" align="center" >
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.times" type="monthrange" value-format="yyyy-MM" start-placeholder="开始时间" end-placeholder="结束时间" @change="val=> timeChange(val, scope.row)" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="所在国家" width="140" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.country" placeholder="请输入"  :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="专业领域" min-width="150" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.zyly" placeholder="请输入"  :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="校（院）名称"  align="center" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.byyxmc" placeholder="请输入"  :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="获取学位" align="center" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.xw" placeholder="请输入"  :disabled="disabled"/>
            </template>
          </el-table-column>

          <el-table-column label="" align="center"  width="60" v-if="!disabled">
            <template slot-scope="scope">
              <i class="el-icon-delete" style="font-size: 16px;color:red;cursor: pointer" @click="deleteStudyExp(scope.$index)"></i>
            </template>
          </el-table-column>

        </el-table>

        <div class="add-line" @click="addStudyExp"  v-if="!disabled">
          <i class="el-icon-plus" ></i><span>添加</span>
        </div>
      </el-form-item>

    </div>

    <!-- 工作经历 -->
    <div class="white-box">
      <div class="label">工作经历</div>
      <el-form-item label="" prop="workExpList">
        <el-table
          :data="dataInfo.workExpList"
          border
          style="width: 100%">
          <el-table-column label="起止年月" width="200" align="center" >
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.times" type="monthrange" value-format="yyyy-MM" start-placeholder="开始时间" end-placeholder="结束时间" @change="val=> timeChange(val, scope.row)" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="所在国家" width="140" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.country" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="担任职务" min-width="150" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.zw" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="工作单位"  align="center" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.workUnit" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="职责与贡献" align="center" width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.zzgx" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>

          <el-table-column label="" align="center"  width="60" v-if="!disabled">
            <template slot-scope="scope">
              <i class="el-icon-delete" style="font-size: 16px;color:red;cursor: pointer" @click="deleteWorkExp(scope.$index)"></i>
            </template>
          </el-table-column>

        </el-table>
        <div class="add-line" @click="addWorkExp"  v-if="!disabled">
          <i class="el-icon-plus" ></i><span>添加</span>
        </div>
      </el-form-item>

    </div>

    <!-- 业绩及荣誉 -->
    <div class="white-box">
      <div class="label">业绩及荣誉</div>

      <el-form-item label="以往所从事工作和研究取得的业绩" prop="performance">
        <el-input v-model="dataInfo.performance" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
      </el-form-item>

      <el-form-item label="荣誉及奖励" prop="ryjjl">
        <el-input v-model="dataInfo.ryjjl" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
      </el-form-item>

      <el-form-item label="主要技术成果" prop="zyjscg">
        <el-input v-model="dataInfo.zyjscg" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
      </el-form-item>

      <el-form-item label="主持国家和地方科技业项目及资助情况" prop="sbrZzqkList">
        <el-table :data="dataInfo.sbrZzqkList" border >
          <el-table-column label="项目类别" min-width="180" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectCategory" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="项目名称" min-width="360" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectName" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>
          <el-table-column label="资助金额（万元）"  align="center" min-width="180">
            <template slot-scope="scope">
              <el-input v-input.float v-model="scope.row.amount" placeholder="" placeholder="请输入" :disabled="disabled"/>
            </template>
          </el-table-column>

          <el-table-column label="" align="center"  width="60" v-if="!disabled">
            <template slot-scope="scope">
              <i class="el-icon-delete" style="font-size: 16px;color:red;cursor: pointer" @click="deleteZzqk(scope.$index)"></i>
            </template>
          </el-table-column>

        </el-table>
        <div class="add-line" @click="addZzqk"  v-if="!disabled">
          <i class="el-icon-plus" ></i><span>添加</span>
        </div>
      </el-form-item>


    </div>


  </el-form>
</template>

<script>
  import { queryGwhLb, dictType, querySb } from '@/api/HttpRequestAPI';
  import { getDictByKey, DICT_TYPES } from '@/constant/Dict';
import {toast} from '@/utils'
import {findByKey, toList, HIGHEST_EDUCATION, YES_OR_NO, SEX_TYPE} from '@/constant/Enums'

export default {
  components: {
  },
  props: {
    dataInfo: {
      type: Object,
      default: ()=>{
        return {
          studyExpList: [{}],//学习经历
          workExpList: [{}],//工作经历
          sbrZzqkList: [],//主持国家和地方科技业项目及资助情况
        }
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let {type} = this.$route.meta
    //校验列表数据
    var checkList = (rule, value, callback, paramsList, canEmptyList) => {
      let isPass = true
      value.forEach((data)=>{
        if(paramsList && paramsList.length > 0) {
          paramsList.forEach(params=>{
            if(data[params] !== 0 && !data[params]) {
              isPass = false
            }
          })
        }
      })
      if (!isPass || (!canEmptyList && value.length == 0)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    //学习经历
    var checkStudyExpList = (rule, value, callback) => {
      let paramsList = ['startDate', 'endDate', 'country', 'zyly', 'byyxmc', 'xw']
      return checkList(rule, value, callback, paramsList)
    };
    //工作经历
    var checkWorkExpList = (rule, value, callback) => {
      let paramsList = ['startDate', 'endDate', 'country', 'zw', 'workUnit', 'zzgx']
      return checkList(rule, value, callback, paramsList)
    };
    //主持国家和地方科技业项目及资助情况
    var checkZzqkList = (rule, value, callback) => {
      let paramsList = ['projectCategory', 'projectName', 'amount']
      return checkList(rule, value, callback, paramsList, true)
    };
    var checkEmail = (rule, value, callback) => {
      const MONEY_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if(!MONEY_REGEX.test(value)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      const MONEY_REGEX = /^1[0-9]{10}$/;
      if(!MONEY_REGEX.test(value)) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    return {
      YES_OR_NO,
      rules: {
        commissionId: [{ required: true, message: '请选择申报平台', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        zjhm: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
        hjszd: [{ required: true, message: '请输入户籍所在地', trigger: 'blur' }],
        sfhy: [{ required: true, message: '请选择是否华裔', trigger: 'change' }],
        birthDay: [{ required: true, message: '请选择出生年月', trigger: 'change' }],
        xl: [{ required: true, message: '请选择最高学历', trigger: 'change' }],
        byyx: [{ required: true, message: '请输入毕业院校', trigger: 'blur' }],
        sxzy: [{ required: true, message: '请输入所学专业', trigger: 'blur' }],
        cszy: [{ required: true, message: '请输入从事专业', trigger: 'blur' }],
        gkhyfl: [{ required: true, message: '请选择归口行业分类', trigger: 'change' }],
        email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { validator: checkEmail, message: '邮箱格式不正确', trigger: 'blur' },
            ],
        phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkPhone, message: '手机号格式不正确', trigger: 'blur' },
            ],
        lxdz: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        xgzdw: [{ required: true, message: '请输入现工作单位', trigger: 'blur' }],
        xgzzw: [{ required: true, message: '请输入现工作职务', trigger: 'blur' }],
        sfclgs: [{ required: true, message: '请选择是否已在临安注册成立公司', trigger: 'change' }],
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        companyAddr: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
        uscc: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        zcsj: [{ required: true, message: '请选择注册时间', trigger: 'change' }],
        studyExpList: [{ validator: checkStudyExpList, message: '请填写学习经历', trigger: 'change' }],
        workExpList: [{ validator: checkWorkExpList, message: '请填写工作经历', trigger: 'change' }],
        performance: [{ required: true, message: '请输入以往所从事工作和研究取得的业绩', trigger: 'blur' }],
        ryjjl: [{ required: true, message: '请输入荣誉及奖励', trigger: 'blur' }],
        zyjscg: [{ required: true, message: '请输入主要技术成果', trigger: 'blur' }],
        sbrZzqkList: [{ validator: checkZzqkList, message: '请填写主持国家和地方科技业项目及资助情况', trigger: 'change' }],
      },
      yesOrNoOptions:toList(YES_OR_NO),//是或否
      sexOptions:toList(SEX_TYPE),//性别类型
      highestEducationOptions:toList(HIGHEST_EDUCATION),//最高学历
      gwhList:[],//申报平台列表
      gkhyflOptions:[],//归口行业类型
      xwOptions:[],//学位



    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gkhyflOptions = await getDictByKey(DICT_TYPES.GKHYFL_TYPES)
      this.xwOptions = await getDictByKey(DICT_TYPES.ACADEMIC_DEGREE)
      this.asyncQueryGwhLb()
    },
    addStudyExp(){
      this.dataInfo.studyExpList.push({})
    },
    deleteStudyExp(index){
      this.dataInfo.studyExpList.splice(index, 1)
    },
    timeChange(times, data){
      if(times && times.length > 1) {
        data.startDate = times[0]
        data.endDate = times[1]
      } else {
        data.startDate = ''
        data.endDate = ''
      }
    },
    addWorkExp(){
      this.dataInfo.workExpList.push({})
    },
    deleteWorkExp(index){
      this.dataInfo.workExpList.splice(index, 1)
    },
    addZzqk(){
      this.dataInfo.sbrZzqkList.push({})
    },
    deleteZzqk(index){
      this.dataInfo.sbrZzqkList.splice(index, 1)
    },
    onZjhmBlur(e){
      let zjhm = e.target.value
      querySb({zjhm}, (resp)=>{
        if(resp.data.sfsb == true) {
          let tip = `证件号【${zjhm}】的申请人已申请过项目，无法再申请项目`
          this.$alert(tip, '提示', {
            type: 'error'
          })
          this.dataInfo.zjhm = ''
        }
      })
    },
    validate(callback){
      this.$refs['form'].validate((valid, object) => {
        callback && callback(valid, object)
      });
    },
    asyncQueryGwhLb(){
      queryGwhLb({}, (resp)=>{
        this.gwhList = resp.data.gwhList
      })
    }
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
